import { defineMessages } from 'react-intl';

export default defineMessages({
  accountHoldersInfo: {
    id: 'unsubscribe.unsuccessful.accountHoldersInfo',
    description:
      'Message for account holders on the communication preferences unsubscribe page',
    defaultMessage:
      'If you have an account, you can unsubscribe and manage all your preferences here.',
  },
  heading: {
    id: 'unsubscribe.unsuccessful.heading',
    description:
      'Heading for the communication preferences unsubscribe unsuccessful page',
    defaultMessage: "Can't unsubscribe",
  },
  preferencesButton: {
    id: 'unsubscribe.unsuccessful.preferencesButton',
    description: 'Text for link to communication preferences settings page',
    defaultMessage: 'Change your preferences',
  },
});
